import { render, staticRenderFns } from "./t-orm-simple-data.vue?vue&type=template&id=4b91dfe4&scoped=true&lang=pug&"
import script from "./t-orm-simple-data.vue?vue&type=script&lang=js&"
export * from "./t-orm-simple-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91dfe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
